import PropTypes from 'prop-types';

/**
 * Prop types automatically provided by preact-iso Route to routed components.
 *
 * @readonly
 * @enum {object}
 *
 * @property {Function} component - The component being rendered by the Route.
 * @property {string} path - Matched URL path.
 * @property {object} query - Parsed query string parameters.
 * @property {object} params - URL parameters extracted from the route path pattern.
 * @property {string} rest - Remaining URL path after the matched portion.
 * @property {boolean} default - Whether the route is the default route.
 *
 * @public
 * @memberof Mojito.Core.Constants
 */
export const routingProps = {
    component: PropTypes.func,
    path: PropTypes.string,
    query: PropTypes.objectOf(PropTypes.string),
    params: PropTypes.objectOf(PropTypes.string),
    rest: PropTypes.string,
    default: PropTypes.bool,
};
